import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import { RavioliCommonContent } from "../../../../modules/content/components/RavioliCommonContent/RavioliCommonContent";
import { RavioliSection } from "../../../../modules/content/components/RavioliSection/RavioliSection";
import type { IVideoBlockProps } from "./VideoBlock.props";

export const VideoBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
  videoBanner,
  videoSource,
  vimeoVideo,
  youtubeVideo,
}: IVideoBlockProps) => {
  const selectedVideo = videoSource === "youtube" ? youtubeVideo : vimeoVideo;
  if (!selectedVideo) return null;
  return (
    <RavioliSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8 md:gap-12">
        <RavioliCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <VideoPlayer
          banner={videoBanner}
          source={videoSource}
          vimeoVideo={vimeoVideo}
          youtubeVideo={youtubeVideo}
        />
      </div>
    </RavioliSection>
  );
};

VideoBlock.displayName = "Block::VideoBlock";
